import { InputBaseComponentProps, TextFieldProps } from '@material-ui/core';
import { ElementType, forwardRef } from 'react';
import NumberFormat, { NumberFormatPropsBase } from 'react-number-format';
import { TextField } from './styles';
import { ColSpan } from '../types';

export type InputMaskProps = Omit<TextFieldProps, 'inputProps'> & {
  colspan?: ColSpan;
  format?: string;
  inputProps?: TextFieldProps['inputProps'] & NumberFormatPropsBase;
};

export const InputMask = forwardRef<HTMLInputElement, InputMaskProps>(
  ({ colspan, format, inputProps, InputProps, ...props }, ref) => {
    return (
      <TextField
        {...props}
        ref={ref}
        $colspan={colspan}
        inputProps={{ format, ...inputProps }}
        InputProps={{
          ...InputProps,
          inputComponent: NumberFormat as ElementType<InputBaseComponentProps>,
        }}
      />
    );
  },
);
